export const ATTR_NAMES_REFERRAL = {
    promotionalCode: 'promotionalCode',
    contactFio: 'contactFio',
    email: 'email',
    phoneNumber: 'phoneNumber',
    legalName: 'legalName',
    regionId: 'regionId',
    serviceProvisionAddress: 'serviceProvisionAddress',
    error: 'error',
    domainUrl: 'domainUrl',
} as const;
